module.exports = __webpack_public_path__ + "img/product_26.16e4584.webp";